var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"fullpage"}},[_c('div',{staticClass:"section page1"},[_vm._v("第一页")]),_c('div',{staticClass:"section page2"},[_vm._v("第二页")]),_c('div',{staticClass:"section"},[_vm._v("第三页")])])])
}]

export { render, staticRenderFns }